var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isTitle !== null && _vm.isTitle === true
        ? _c(
            "div",
            { staticClass: "breadcrumb-layout" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页")
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.typeName))])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v(_vm._s(_vm.typeName))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block row" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("温馨提示：")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qualiType.desc || "无"))])
      ]),
      _vm._v(" "),
      _vm.showMerchtQuali
        ? [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.qualiType }
              },
              [
                _c(
                  "div",
                  { staticClass: "simple-form" },
                  _vm._l(_vm.qualiType.attrList, function(
                    qualiTypeAttr,
                    index
                  ) {
                    return (qualiTypeAttr.qualiAttr.code !=
                      "bizTermStartDate" &&
                      qualiTypeAttr.qualiAttr.code != "bizTermEndDate") ||
                      ((qualiTypeAttr.qualiAttr.code == "bizTermStartDate" ||
                        qualiTypeAttr.qualiAttr.code == "bizTermEndDate") &&
                        _vm.displayBizTermTime == true)
                      ? _c("div", { staticClass: "form-group center" }, [
                          _c("div", { staticClass: "form-label" }, [
                            _c(
                              "label",
                              { class: { required: qualiTypeAttr.required } },
                              [_vm._v(_vm._s(qualiTypeAttr.qualiAttr.name))]
                            )
                          ]),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 0
                            ? _c(
                                "div",
                                { staticClass: "form-value" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key: qualiTypeAttr.id,
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              required: true,
                                              type: "string",
                                              message: "该属性不能为空",
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          qualiTypeAttr.qualiAttr.code ==
                                          "orgName"
                                            ? _c(
                                                "div",
                                                [
                                                  _c("el-input", {
                                                    staticClass: "width-2x",
                                                    attrs: {
                                                      change: _vm.changeOrgName(
                                                        qualiTypeAttr.qualiAttrVal
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("el-input", {
                                                    staticClass: "width-2x",
                                                    attrs: {
                                                      disabled:
                                                        qualiTypeAttr.qualiAttrDisabled
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ]
                                      )
                                    : _c("el-form-item", [
                                        qualiTypeAttr.qualiAttr.code ==
                                        "realMerchantCode"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-input",
                                                  {
                                                    staticClass: "width-2x",
                                                    attrs: {
                                                      placeholder:
                                                        "请输入实体集团代码"
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.realMerchantCodeInput
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  },
                                                  [
                                                    _c("el-button", {
                                                      attrs: {
                                                        slot: "append",
                                                        icon: "el-icon-search"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.getRealMerchantCode(
                                                            qualiTypeAttr.qualiAttrVal
                                                          )
                                                        }
                                                      },
                                                      slot: "append"
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : qualiTypeAttr.qualiAttr.code ==
                                            "realComCode"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-input",
                                                  {
                                                    staticClass: "width-2x",
                                                    attrs: {
                                                      placeholder:
                                                        "请输入实体公司代码"
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.realComCodeInput
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  },
                                                  [
                                                    _c("el-button", {
                                                      attrs: {
                                                        slot: "append",
                                                        icon: "el-icon-search"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.getRealComCode(
                                                            qualiTypeAttr.qualiAttrVal
                                                          )
                                                        }
                                                      },
                                                      slot: "append"
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c("el-input", {
                                                  staticClass: "width-2x",
                                                  attrs: {
                                                    disabled:
                                                      qualiTypeAttr.qualiAttrDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      qualiTypeAttr.qualiAttrVal,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        qualiTypeAttr,
                                                        "qualiAttrVal",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "qualiTypeAttr.qualiAttrVal"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                      ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 1
                            ? _c(
                                "div",
                                { staticClass: "form-value width-2x" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key: qualiTypeAttr.id,
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              required: true,
                                              type: "string",
                                              message: "该属性不能为空",
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "textarea"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "textarea"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 2
                            ? _c(
                                "div",
                                { staticClass: "form-value width-2x" },
                                [
                                  qualiTypeAttr.required &&
                                  qualiTypeAttr.qualiAttr.code ==
                                    "registCapital"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key: qualiTypeAttr.id,
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              validator:
                                                _vm.validators.validCapital,
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "number",
                                              min: "0",
                                              placeholder: "请输入数字"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key: qualiTypeAttr.id,
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              validator:
                                                _vm.validators.validNumber,
                                              trigger: "blur"
                                            }
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "number",
                                              min: "0",
                                              placeholder: "请输入数字"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "number",
                                              min: "0",
                                              placeholder: "请输入数字"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 3
                            ? _c(
                                "div",
                                { staticClass: "form-value width-2x" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          key: qualiTypeAttr.id,
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              required: true,
                                              type: "date",
                                              message: "该属性不能为空",
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "date",
                                              placeholder: "选择日期"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              disabled:
                                                qualiTypeAttr.qualiAttrDisabled,
                                              type: "date",
                                              placeholder: "选择日期"
                                            },
                                            model: {
                                              value: qualiTypeAttr.qualiAttrVal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  qualiTypeAttr,
                                                  "qualiAttrVal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "qualiTypeAttr.qualiAttrVal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 4
                            ? _c(
                                "div",
                                { staticClass: "form-value width-3x" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              validator:
                                                _vm.validators.validRadio,
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          qualiTypeAttr.qualiAttr.code ==
                                          "bizTermType"
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          qualiTypeAttr.qualiAttrDisabled
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.bizTermTypeChange
                                                      },
                                                      model: {
                                                        value:
                                                          qualiTypeAttr.qualiAttrVal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            qualiTypeAttr,
                                                            "qualiAttrVal",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "qualiTypeAttr.qualiAttrVal"
                                                      }
                                                    },
                                                    _vm._l(
                                                      qualiTypeAttr.qualiAttrOptionList,
                                                      function(option) {
                                                        return _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label:
                                                                option.value
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  )
                                                ],
                                                1
                                              )
                                            : qualiTypeAttr.qualiAttr.code ==
                                              "integratedFlag"
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          qualiTypeAttr.qualiAttrDisabled
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.isIntegratedChange
                                                      },
                                                      model: {
                                                        value:
                                                          qualiTypeAttr.qualiAttrVal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            qualiTypeAttr,
                                                            "qualiAttrVal",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "qualiTypeAttr.qualiAttrVal"
                                                      }
                                                    },
                                                    _vm._l(
                                                      qualiTypeAttr.qualiAttrOptionList,
                                                      function(option) {
                                                        return _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label:
                                                                option.value
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          qualiTypeAttr.qualiAttrDisabled
                                                      },
                                                      model: {
                                                        value:
                                                          qualiTypeAttr.qualiAttrVal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            qualiTypeAttr,
                                                            "qualiAttrVal",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "qualiTypeAttr.qualiAttrVal"
                                                      }
                                                    },
                                                    _vm._l(
                                                      qualiTypeAttr.qualiAttrOptionList,
                                                      function(option) {
                                                        return _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label:
                                                                option.value
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  )
                                                ],
                                                1
                                              )
                                        ]
                                      )
                                    : _c("el-form-item", [
                                        qualiTypeAttr.qualiAttr.code ==
                                        "bizTermType"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        qualiTypeAttr.qualiAttrDisabled
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.bizTermTypeChange
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  },
                                                  _vm._l(
                                                    qualiTypeAttr.qualiAttrOptionList,
                                                    function(option) {
                                                      return _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: option.value
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.text)
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                )
                                              ],
                                              1
                                            )
                                          : qualiTypeAttr.qualiAttr.code ==
                                            "integratedFlag"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        qualiTypeAttr.qualiAttrDisabled
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.isIntegratedChange
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  },
                                                  _vm._l(
                                                    qualiTypeAttr.qualiAttrOptionList,
                                                    function(option) {
                                                      return _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: option.value
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.text)
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        qualiTypeAttr.qualiAttrDisabled
                                                    },
                                                    model: {
                                                      value:
                                                        qualiTypeAttr.qualiAttrVal,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          qualiTypeAttr,
                                                          "qualiAttrVal",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "qualiTypeAttr.qualiAttrVal"
                                                    }
                                                  },
                                                  _vm._l(
                                                    qualiTypeAttr.qualiAttrOptionList,
                                                    function(option) {
                                                      return _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: option.value
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.text)
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                )
                                              ],
                                              1
                                            )
                                      ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 5
                            ? _c(
                                "div",
                                { staticClass: "form-value checkbox-space" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "attrList." +
                                              index +
                                              ".qualiAttrVal",
                                            rules: {
                                              validator:
                                                _vm.validators.validCheckbox,
                                              trigger: "change"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value:
                                                  qualiTypeAttr.qualiAttrVal,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    qualiTypeAttr,
                                                    "qualiAttrVal",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "qualiTypeAttr.qualiAttrVal"
                                              }
                                            },
                                            _vm._l(
                                              qualiTypeAttr.qualiAttrOptionList,
                                              function(option) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      label: option.value
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(option.text))]
                                                )
                                              }
                                            )
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value:
                                                  qualiTypeAttr.qualiAttrVal,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    qualiTypeAttr,
                                                    "qualiAttrVal",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "qualiTypeAttr.qualiAttrVal"
                                              }
                                            },
                                            _vm._l(
                                              qualiTypeAttr.qualiAttrOptionList,
                                              function(option) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      label: option.value
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(option.text))]
                                                )
                                              }
                                            )
                                          )
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 6
                            ? _c("div", { staticClass: "form-value" }, [
                                _c(
                                  "div",
                                  { staticClass: "file-area clearfix" },
                                  [
                                    qualiTypeAttr.required
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "attrList." +
                                                index +
                                                ".fileItems",
                                              rules: {
                                                validator:
                                                  _vm.validators
                                                    .validTagFileItems,
                                                trigger: "change"
                                              }
                                            }
                                          },
                                          [
                                            qualiTypeAttr.qualiAttr.code ==
                                            "bizLicense"
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    qualiTypeAttr.fileItems,
                                                    function(
                                                      fileItem,
                                                      indexL21
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            height: "auto",
                                                            overflow: "hidden"
                                                          }
                                                        },
                                                        [
                                                          _vm.integratedFlag &&
                                                          fileItem.tag.indexOf(
                                                            "（三证合一）"
                                                          ) >= 0
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "swb-file-item",
                                                                    {
                                                                      attrs: {
                                                                        trackKey:
                                                                          index +
                                                                          "-" +
                                                                          indexL21,
                                                                        editable:
                                                                          fileItem.editable,
                                                                        showTag:
                                                                          fileItem.showTag,
                                                                        onUploaded:
                                                                          _vm.echoUploadedFileInfo,
                                                                        tag:
                                                                          fileItem.tag,
                                                                        fileName:
                                                                          fileItem.fileName,
                                                                        fileUuid:
                                                                          fileItem.fileUuid,
                                                                        fileBrowseUrl:
                                                                          fileItem.fileBrowseUrl,
                                                                        fileDownloadUrl:
                                                                          fileItem.fileDownloadUrl
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  qualiTypeAttr
                                                                    .qualiAttr
                                                                    .code ==
                                                                  "bizLicense"
                                                                    ? _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "swb-btn-link",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.getBizLicenseOcrResult(
                                                                                fileItem.fileUuid
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "识别" +
                                                                              _vm._s(
                                                                                fileItem.tag
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.integratedFlag &&
                                                          fileItem.tag.indexOf(
                                                            "（三证合一）"
                                                          ) < 0
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "swb-file-item",
                                                                    {
                                                                      attrs: {
                                                                        trackKey:
                                                                          index +
                                                                          "-" +
                                                                          indexL21,
                                                                        editable:
                                                                          fileItem.editable,
                                                                        showTag:
                                                                          fileItem.showTag,
                                                                        onUploaded:
                                                                          _vm.echoUploadedFileInfo,
                                                                        tag:
                                                                          fileItem.tag,
                                                                        fileName:
                                                                          fileItem.fileName,
                                                                        fileUuid:
                                                                          fileItem.fileUuid,
                                                                        fileBrowseUrl:
                                                                          fileItem.fileBrowseUrl,
                                                                        fileDownloadUrl:
                                                                          fileItem.fileDownloadUrl
                                                                      }
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  qualiTypeAttr
                                                                    .qualiAttr
                                                                    .code ==
                                                                  "bizLicense"
                                                                    ? _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "swb-btn-link",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.getBizLicenseOcrResult(
                                                                                fileItem.fileUuid
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "识别" +
                                                                              _vm._s(
                                                                                fileItem.tag
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    }
                                                  )
                                                )
                                              : _c(
                                                  "div",
                                                  _vm._l(
                                                    qualiTypeAttr.fileItems,
                                                    function(
                                                      fileItem,
                                                      indexL21
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            height: "auto",
                                                            overflow: "hidden"
                                                          }
                                                        },
                                                        [
                                                          _c("swb-file-item", {
                                                            attrs: {
                                                              trackKey:
                                                                index +
                                                                "-" +
                                                                indexL21,
                                                              editable:
                                                                fileItem.editable,
                                                              showTag:
                                                                fileItem.showTag,
                                                              onUploaded:
                                                                _vm.echoUploadedFileInfo,
                                                              tag: fileItem.tag,
                                                              fileName:
                                                                fileItem.fileName,
                                                              fileUuid:
                                                                fileItem.fileUuid,
                                                              fileBrowseUrl:
                                                                fileItem.fileBrowseUrl,
                                                              fileDownloadUrl:
                                                                fileItem.fileDownloadUrl
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          qualiTypeAttr
                                                            .qualiAttr.code ==
                                                          "bizLicense"
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "swb-btn-link",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.getBizLicenseOcrResult(
                                                                        fileItem.fileUuid
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "识别" +
                                                                      _vm._s(
                                                                        fileItem.tag
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                )
                                          ]
                                        )
                                      : _c("el-form-item", [
                                          qualiTypeAttr.qualiAttr.code ==
                                          "bizLicense"
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  qualiTypeAttr.fileItems,
                                                  function(fileItem, indexL21) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          height: "auto",
                                                          overflow: "hidden"
                                                        }
                                                      },
                                                      [
                                                        _vm.integratedFlag &&
                                                        fileItem.tag.indexOf(
                                                          "（三证合一）"
                                                        ) >= 0
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "swb-file-item",
                                                                  {
                                                                    attrs: {
                                                                      trackKey:
                                                                        index +
                                                                        "-" +
                                                                        indexL21,
                                                                      editable:
                                                                        fileItem.editable,
                                                                      showTag:
                                                                        fileItem.showTag,
                                                                      onUploaded:
                                                                        _vm.echoUploadedFileInfo,
                                                                      tag:
                                                                        fileItem.tag,
                                                                      fileName:
                                                                        fileItem.fileName,
                                                                      fileUuid:
                                                                        fileItem.fileUuid,
                                                                      fileBrowseUrl:
                                                                        fileItem.fileBrowseUrl,
                                                                      fileDownloadUrl:
                                                                        fileItem.fileDownloadUrl
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                qualiTypeAttr
                                                                  .qualiAttr
                                                                  .code ==
                                                                "bizLicense"
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "swb-btn-link",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.getBizLicenseOcrResult(
                                                                              fileItem.fileUuid
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "识别" +
                                                                            _vm._s(
                                                                              fileItem.tag
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.integratedFlag &&
                                                        fileItem.tag.indexOf(
                                                          "（三证合一）"
                                                        ) < 0
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "swb-file-item",
                                                                  {
                                                                    attrs: {
                                                                      trackKey:
                                                                        index +
                                                                        "-" +
                                                                        indexL21,
                                                                      editable:
                                                                        fileItem.editable,
                                                                      showTag:
                                                                        fileItem.showTag,
                                                                      onUploaded:
                                                                        _vm.echoUploadedFileInfo,
                                                                      tag:
                                                                        fileItem.tag,
                                                                      fileName:
                                                                        fileItem.fileName,
                                                                      fileUuid:
                                                                        fileItem.fileUuid,
                                                                      fileBrowseUrl:
                                                                        fileItem.fileBrowseUrl,
                                                                      fileDownloadUrl:
                                                                        fileItem.fileDownloadUrl
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                qualiTypeAttr
                                                                  .qualiAttr
                                                                  .code ==
                                                                "bizLicense"
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "swb-btn-link",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.getBizLicenseOcrResult(
                                                                              fileItem.fileUuid
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "识别" +
                                                                            _vm._s(
                                                                              fileItem.tag
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                )
                                              )
                                            : _c(
                                                "div",
                                                _vm._l(
                                                  qualiTypeAttr.fileItems,
                                                  function(fileItem, indexL21) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          height: "auto",
                                                          overflow: "hidden"
                                                        }
                                                      },
                                                      [
                                                        _c("swb-file-item", {
                                                          attrs: {
                                                            trackKey:
                                                              index +
                                                              "-" +
                                                              indexL21,
                                                            editable:
                                                              fileItem.editable,
                                                            showTag:
                                                              fileItem.showTag,
                                                            onUploaded:
                                                              _vm.echoUploadedFileInfo,
                                                            tag: fileItem.tag,
                                                            fileName:
                                                              fileItem.fileName,
                                                            fileUuid:
                                                              fileItem.fileUuid,
                                                            fileBrowseUrl:
                                                              fileItem.fileBrowseUrl,
                                                            fileDownloadUrl:
                                                              fileItem.fileDownloadUrl
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        qualiTypeAttr.qualiAttr
                                                          .code == "bizLicense"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "swb-btn-link",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.getBizLicenseOcrResult(
                                                                      fileItem.fileUuid
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "识别" +
                                                                    _vm._s(
                                                                      fileItem.tag
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              )
                                        ])
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          qualiTypeAttr.qualiAttr.type == 7
                            ? _c(
                                "div",
                                { staticClass: "form-value width-2x" },
                                [
                                  qualiTypeAttr.required
                                    ? _c(
                                        "el-form-item",
                                        [
                                          _c("swb-region", {
                                            ref: "swb_region",
                                            refInFor: true,
                                            attrs: {
                                              item: _vm.addressVal,
                                              required: true
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            model: {
                                              value: _vm.street,
                                              callback: function($$v) {
                                                _vm.street = $$v
                                              },
                                              expression: "street"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-form-item",
                                        [
                                          _c("swb-region", {
                                            ref: "swb_region",
                                            refInFor: true,
                                            attrs: {
                                              item: _vm.addressVal,
                                              required: false
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            model: {
                                              value: _vm.street,
                                              callback: function($$v) {
                                                _vm.street = $$v
                                              },
                                              expression: "street"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  })
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8540e8f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8540e8f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/quali/MerchantQualiEdit.vue
// module id = 3685
// module chunks = 0